import './theme-layout-preferences';


window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};

window.silesia.layout.schemaSwitcher = function() {
    let schema;
    const cl = document.querySelector('html').classList;

    return {
        init: function() {
            if(!window.silesia.layout.schemaSwitcher.loaded) {
                var schema = window.silesia.layout.preferencesManager.getPreference('schema');
                window.silesia.layout.preferencesManager.setPreference('schema',schema);
                window.silesia.layout.schemaSwitcher.loaded = true;
                this.$refs.checkbox.checked = (schema === 'dark');
            }
        },
        toggle: function() {
            if(this.$refs.checkbox.checked) {
                schema = 'dark';
                cl.add('is-style-dark-schema');
            } else {
                schema = 'default';
                cl.remove('is-style-dark-schema');
            }

            window.silesia.layout.preferencesManager.setPreference('schema', schema);
            
            // //Zapisz schemat w sesji
            // //Backend dodaje klasę do tagu <HTML>
            // fetch('?', {
            //     method: 'POST',
            //     headers: {
            //         'Content-Type': 'application/x-www-form-urlencoded',
            //         'X-Requested-With': 'XMLHttpRequest'
            //     },
            //     body: new URLSearchParams({
            //         _switch_theme_schema: schema
            //     })
            // }); 
        }
    }
};